import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const JobApplicationService = {
  create: async (data) => {
    const response = await apiService.post("/jobapplications", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/jobapplications/${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  updateStatus: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/jobapplications/${id}/status`,
        updatedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async ({ page = 1, pageSize = 20 } = {}) => {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(
      `/jobapplications?${params.toString()}`
    );

    return response.data;
  },

  getDetail: async (id) => {
    const response = await apiService.get(`/jobapplications/${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete(`/jobapplications/${id}`);
    return response.data;
  },
};

export default JobApplicationService;
